/* eslint-disable array-callback-return */
export const convertObjToArr = (obj: any): string[] =>
  Object.keys(obj).filter((key: string) => {
    if (obj[key] === true) return key as string;
  }) as string[];
